var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-btn',{staticClass:"mx-2",attrs:{"fab":"","small":""},on:{"click":_vm.onClickDarkMode}},[_c('v-icon',{attrs:{"color":_vm.iconTheme}},[_vm._v(" "+_vm._s(_vm.iconSource)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }